import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createBlock(_component_v_text_field, {
    id: _ctx.fieldId,
    density: "comfortable",
    variant: "solo",
    flat: "",
    "persistent-placeholder": "",
    "validate-on": "blur",
    label: _ctx.label,
    "prepend-icon": _ctx.icon,
    type: _ctx.type,
    autocomplete: _ctx.autocomplete,
    rules: _ctx.rules,
    readonly: _ctx.readonly ? _ctx.readonly : false
  }, null, 8, ["id", "label", "prepend-icon", "type", "autocomplete", "rules", "readonly"]))
}